import script from "./AppVersionOutdatedModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppVersionOutdatedModal.vue?vue&type=script&lang=ts&setup=true"

import "./AppVersionOutdatedModal.vue?vue&type=style&index=0&id=f16b8244&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f16b8244"]])

export default __exports__